import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { Chart } from 'chart.js';


@Component({
    selector: 'cairo-chart',
    template: `
        <canvas></canvas>
    `,
    styles: [':host { display: block; width: 100%; height: 100%; }']
})
export class CairoChartComponent implements OnInit {
    private chart : any = null;

    /** Classic UI look: solid grey/green lines, canvas keeps its aspect ratio (no fixed-height parent). */
    @Input() classic: boolean = false;

    constructor(private el: ElementRef) { }
    ngOnInit() { }

    private get canvas(): HTMLCanvasElement {
        return this.el.nativeElement.querySelector('canvas');
    }

    /** @param selector kept for backwards compatibility; the component always draws on its own canvas. */
    public load(wave: number[], selector?: string) {
        if (this.chart && this.chart.destroy) {
            this.chart.destroy();
        }

        const current = this.classic
            ? { borderWidth: 3, borderColor: '#58585a' }
            : { borderWidth: 2.5, borderColor: '#98989d', borderDash: [5, 4] };

        this.chart = new Chart(this.canvas, {
            type: 'line',
            data: {
                datasets: [Object.assign({
                    data: wave.map((item) => { return {x: item[0], y: item[1]} }),
                    fill: false,
                    pointRadius: 0,
                }, current)]
            },
            options: {
                responsive: true,
                maintainAspectRatio: this.classic,
                legend: { display: false },
                scales: {
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: "Wavelength(nm)",
                        },
                        type: 'linear',
                        position: 'bottom',
                        ticks: {
                            min: Math.min.apply(Math, wave.map(item => item[0])),
                            max: Math.max.apply(Math, wave.map(item => item[0])),
                        }
                    }],
                    yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: "R(%)"
                        },
                        ticks: {
                            min: 0,
                            stepSize: 10
                        }
                    }]
                }
            }
        });
    }

    public add(wave: number[]) {
        if (!this.chart) { return; }

        const target = this.classic
            ? { pointRadius: 1, borderWidth: 3, borderColor: '#579d1e' }
            : { pointRadius: 0, borderWidth: 2.5, borderColor: '#0e9f66' };

        this.chart.data.datasets[0].label = 'current';
        this.chart.data.datasets.push(Object.assign({
            label: 'target',
            data: wave.map((item) => { return {x: item[0], y: item[1]} }),
            fill: false,
        }, target));
        this.chart.update();
    }
}
